import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { PageContent } from 'components/quote/zywave-redirect';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import ZywaveRedirectPageStore, {
  ZywaveRedirectPageStoreContext,
} from 'store/pages/quote/zywave-redirect-page/pageStore';

const ZywaveQuoteRedirectPage: React.FC = observer(() => {
  const domainParams = useQuoteDomainParams();
  const pageStore = useMemo(
    () => new ZywaveRedirectPageStore(domainParams),
    [domainParams.groupId, domainParams.periodId, domainParams.cartId],
  );

  return (
    <ZywaveRedirectPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </ZywaveRedirectPageStoreContext.Provider>
  );
});

export default ZywaveQuoteRedirectPage;
